import { BarChart4, TicketCheck, UserCheck } from 'lucide-react';
import { useNavigate } from 'react-router';

import { cn } from '~/styles/extended-theme';

import { Button } from '../ui/button';

import { FeatureCard } from './feature-card';

export function AthletesSection() {
  const navigate = useNavigate();

  const features = [
    {
      title: 'Find Gyms, Classes and Events',
      icon: <TicketCheck size={48} className="text-destructive" />,
      description: `Discover top martial arts gyms in your home town or wherever you travel.`,
      imageSrc: '/img/athlete_vp01.png',
      imageAlt: 'athlete vp01',
    },
    {
      title: 'Train and learn with other athletes',
      icon: <UserCheck size={48} className="text-destructive" />,
      description: `Drop-in to local gyms when you’re traveling to meet, train, and learn in local classes and events.`,
      imageSrc: '/img/athlete_vp02.png',
      imageAlt: 'athlete vp02',
    },
    {
      title: 'Track Your Progress',
      icon: <BarChart4 size={48} className="text-destructive" />,
      description: `Monitor workouts, submissions, and skills over time.`,
      imageSrc: '/img/athlete_vp03.png',
      imageAlt: 'athlete vp03',
    },
  ];

  return (
    <div
      className="relative flex flex-col items-center overflow-hidden bg-primary pb-[50px] desktop:pb-[140px]"
      id="athletes-section"
    >
      <div
        className={cn(
          '-z-1 absolute right-1/2 translate-x-1/2 overflow-hidden',
          '-top-[30px]',
          'tablet:-top-[50px]',
          'desktop:-top-[15px] desktop:translate-x-[115px]',
        )}
      >
        <img
          src="/img/athlete_bg.png"
          alt="athlete bg"
          className={cn(
            'opacity-[25%]',
            'h-[313px] w-[470px] min-w-[470px]',
            'tablet:h-[611px] tablet:w-[916px] tablet:min-w-[916px]',
          )}
        />
      </div>
      <div
        className={cn(
          'flex flex-col gap-8',
          'w-[361px] pt-[225px]',
          'tablet:w-[596px] tablet:pt-[310px]',
          'desktop:w-[834px] desktop:pt-[100px]',
        )}
      >
        <div className="flex w-full justify-end">
          <div className="mb-7 flex flex-col gap-4 desktop:mb-10 desktop:w-[399px] desktop:min-w-[399px]">
            <p className="text-subtitle1 text-destructive">ATHLETES</p>
            <p className="font-mono text-h2 text-white">
              Train Anywhere. Meet and learn with others.
            </p>
            <p className="text-body1 text-white">
              Wherever you train, Fighters Passport helps you find gyms, meet and learn from other
              athletes, and track your progress.
            </p>
          </div>
        </div>

        {features.map((feature, index) => (
          <FeatureCard key={index} {...feature} variant="athlete" />
        ))}

        <div className="flex flex-col gap-4 rounded-2xl border border-gray-400 p-6 tablet:mt-8 tablet:flex-row tablet:items-center tablet:justify-center">
          <p className="text-h6 text-white">Sign up is free. Join Fighters Passport today!</p>
          <Button
            variant="destructive"
            size="lg"
            className="px-4 text-center text-xs text-white md:h-[42px] md:px-8 md:text-sm"
            onClick={() => navigate('/login')}
          >
            FIND YOUR NEXT GYM
          </Button>
        </div>
      </div>
    </div>
  );
}
